import { useMemo } from 'react';
import styles from './Footer.module.scss';
import FooterLogo from '@/ui-assets/images/footer-logo.png';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

export function Footer({ className = '' }: { className?: string }) {
  const currentYear = useMemo(() => new Date().getFullYear(), []);
  const { t } = useTranslation();

  return (
    <footer className={classNames(styles.footerContainer, 'footer-container', className)}>
      <div>
        <p className={styles.help}>{t("other.for_help")} <a href="mailto:webmaster@thaipbs.or.th">webmaster@thaipbs.or.th</a></p>
      </div>
      <div className={styles.footerCopyright}>
        <img
          src={FooterLogo}
          alt="Thai PBS"
          className={styles.logo}
          width={16}
          height={18}
        />
        <p className={styles.text}>
          &copy;{currentYear} องค์การกระจายเสียงและแพร่ภาพสาธารณะแห่งประเทศไทย
        </p>
      </div>
    </footer>
  );
}
